export const getInitiatePaymentErrorMessage = (
  errorCode: string,
  t: (key: string, options?: { defaultValue: string }) => string,
) =>
  errorCode === "SERVICE_UNAVAILABLE"
    ? t("paymentPage.card.maintenance", {
        defaultValue: "Payments are temporarily unavailable for maintenance. Please try again later.",
      })
    : t("paymentPage.card.notAccepted")
